import React from 'react'

const AdditionalChargesModalMobile = () => {
  return <div>AdditionalChargesModalMobile</div>
}

export default AdditionalChargesModalMobile
